import { render } from "./JSONView.vue?vue&type=template&id=7f933bc9&scoped=true"
import script from "./JSONView.vue?vue&type=script&lang=js"
export * from "./JSONView.vue?vue&type=script&lang=js"

import "./JSONView.vue?vue&type=style&index=0&id=7f933bc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f933bc9"]])

export default __exports__